import { getWidgetsList } from 'api';
import { IWidgetsListRequest } from 'api/types/widgets';
import { call, put } from 'redux-saga/effects';
import { GenericGetAction } from 'sagas';
import { widgetsActions } from 'slices';

function* getWidgetsListSaga({ payload }: GenericGetAction<IWidgetsListRequest>) {
  if (!payload) {
    return null;
  }

  const { response, error } = yield call(getWidgetsList, payload.personId);

  if (response) {
    yield put(widgetsActions.success(response));
  } else {
    yield put(widgetsActions.failure(error));
  }
}

export { getWidgetsListSaga };
